/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enums_Beweegthema_Eendansuitvoeren4Inputs */

const nl_enums_beweegthema_eendansuitvoeren4 = /** @type {(inputs: Enums_Beweegthema_Eendansuitvoeren4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een dans uitvoeren`)
};

/**

* @param {Enums_Beweegthema_Eendansuitvoeren4Inputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const enums_beweegthema_eendansuitvoeren4 = /** @type {((inputs?: Enums_Beweegthema_Eendansuitvoeren4Inputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enums_Beweegthema_Eendansuitvoeren4Inputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_enums_beweegthema_eendansuitvoeren4(inputs)
});
export { enums_beweegthema_eendansuitvoeren4 as "enums.Beweegthema.EenDansUitvoeren" }